export default __webpack_public_path__ + "static/media/gallery_00.5f25994c.jpg";